import React, { Component } from "react";

import { twistDimensions } from "@formant/core/model/twistDimensions";
import { HStack } from "@formant/ui/component/common/HStack";

import { NumberField } from "../common/NumberField";
import { SelectField } from "../common/SelectField";
import * as styles from "./JoystickAxisConfiguration.scss";

export interface IJoystickAxisConfigurationFakeProps {}

export class JoystickAxisConfigurationFake extends Component<IJoystickAxisConfigurationFakeProps> {
    public render() {
        return (
            <HStack
                hAlign="space-between"
                vAlign="center"
                className={styles["joystick-axis-configuration"]}
            >
                <span className={styles["axis-label"]}>axis</span>

                <SelectField
                    label="Twist dimension"
                    small={true}
                    disabled={true}
                >
                    <option key="None" value={undefined}>
                        None
                    </option>
                    {twistDimensions.map(_ => (
                        <option key={_} value={_}>
                            {_}
                        </option>
                    ))}
                </SelectField>
                <NumberField
                    label="GamepadAxis"
                    small={true}
                    disabled={true}
                    numberValue={0}
                    className={styles.scale}
                />
                <NumberField
                    label="Scale"
                    small={true}
                    disabled={true}
                    numberValue={0}
                    className={styles.scale}
                />
                <NumberField
                    label="Exponent"
                    small={true}
                    disabled={true}
                    numberValue={0}
                    className={styles.exponent}
                />
            </HStack>
        );
    }
}
